export default "__VITE_ASSET__3ed1692c__"